import React from 'react';
import { ToastContainer } from 'react-toastify';
import Navbar from '../components/PartnerPage/Navbar';
import HeroSectionWithQuickQuote from '../components/PartnerPage/HeroWithQuickQuote'
import Footer from '../components/PartnerPage/Footer';
import ShipOverview from 'components/PartnerPage/ShipOverview';
import FeaturesGrid from 'components/PartnerPage/FeaturesGrid';
import Newsletter from 'components/PartnerPage/Newsletter';
import affordableRatesImage from 'images/affordable-rates.jpg';
import onTimeGuaranteeImage from 'images/on-time-guarantee.jpg';
import complimentaryInsuranceImage from 'images/complimentary-insurance.jpg';
import personalServiceImage from 'images/personal-service.jpg';
import realTimeTrackingImage from 'images/real-time-tracking.jpg';
import unmatchedConvenienceImage from 'images/unmatched-convenience.jpg';
import PebbleBeachLogo from 'images/pebble-beach-logo.png';

export default function PebbleBeachPartnerPage() {
  const reasons = [{
      title: 'Why Ship?',
      description: `
        Elevate your Pebble Beach experience by leaving the logistics to us.
        Ship your clubs directly to the course, ensuring they're ready when you are,
        and enjoy peace of mind knowing your gear is handled with care.
      `,
    }, {
      title: 'How it Works',
      description: `
        Simply input your shipping details above, select your preferred delivery
        speed, print your label, and affix it to your bag. With your pickup arranged,
        you can sit back and relax, knowing your clubs will be ready when you are.
      `,
    }, {
      title: 'What to Expect',
      description: `
        Expect seamless logistics and exceptional service from doorstep to fairway.
        With dedicated customer support and real-time tracking, rest assured your clubs
        will be waiting for you at the resort, allowing you to focus on what truly
        matters - your game.
      `,
    },
  ];

  const features = [{
      image: affordableRatesImage,
      title: 'Affordable Rates',
      description: `
        Customers enjoy savings up to 60% lower than regular carrier costs
        and many times on par with using the airlines.
      `
    }, {
      image: onTimeGuaranteeImage,
      title: 'On-Time Guarantee',
      description: `
        Rest assured knowing your shipment will arrive when promised with our on-time guarantee,
        ensuring peace of mind and reliability every step of the way.
      `
    }, {
      image: complimentaryInsuranceImage,
      title: 'Complimentary Insurance',
      description: `
        We understand the importance of protecting your sticks in transit. That's why
        we include $1,000 of complimentary insurance on all golf bag shipments.
      `
    }, {
      image: personalServiceImage,
      title: 'Personal Service',
      description: `
        To our team, you're not just another customer - you're our most important one. Enjoy
        personal customer service 7 days a week via phone, email, text, or live chat.
      `
    }, {
      image: realTimeTrackingImage,
      title: 'Real-Time Tracking',
      description: `
        Stay informed and in control with our real-time tracking feature, allowing you to monitor the
        progress of your shipment from pickup to delivery, anytime and anywhere.
      `
    }, {
      image: unmatchedConvenienceImage,
      title: 'Unmatched Convenience',
      description: `
        We are truly dedicated to enhancing and simplifying your travel experience. That's why
        we'll come to you! We offer the option to have your golf clubs and luggage picked up
        directly from your home, office, pro shop, hotel, and more.
      `
    }
  ];

  return (
    <>
        <ToastContainer />
        {/* Background image container with responsive height */}
        <div className="relative font-poppins bg-cover bg-center backgroundImage">
          <Navbar NavLogo={PebbleBeachLogo} subdomain="pbgr" customCTAPath="/ship" />
          <HeroSectionWithQuickQuote
            header="Time at Pebble Beach® is precious. Spend it on the course, not at baggage claim."
            subheader="
              From your doorway to the fairway. Ship golf clubs and luggage directly to and from Pebble Beach Resorts®
            "
            allowedLocations={window.gon?.allowed_locations}
          />
        </div>

        <main className="flex flex-col items-center justify-between w-full font-poppins">
          <ShipOverview reasons={reasons}>
            <p className="text-[28px] lg:text-[32px] font-bold text-[#1C2938] mb-5">
              Ship Sticks x Pebble Beach
            </p>
            <p className="text-[#1C2938] text-lg mb-7">
              Pebble Beach has partnered with Ship Sticks as its <b>Premier Partner for shipping clubs
              to and from The Resort.</b> Renowned for their reliability and dedication to the golfing
              community, Ship Sticks ensures an elevated experience that aligns seamlessly with Pebble
              Beach&apos;s commitment to excellence.
            </p>
            <p className="text-[#231F20] text-lg">
              Pebble Beach Resorts recommends golfers ship their clubs
              to enhance their stay, providing a hassle-free journey from
              start to finish. With Ship Sticks, the Pebble Beach team can
              anticipate arrivals and ensure clubs are ready and waiting,
              allowing guests to focus on enjoying every moment of their stay.
            </p>
          </ShipOverview>
          <FeaturesGrid header="What you get with Ship Sticks" features={features} />
        </main>
      <Footer
        bgColor="#231F20" FooterLogo={PebbleBeachLogo} brand="shipsticks"
        shipLinkPath="/ship" subdomain="pbgr" supportPhoneNumber="(561) 429-3900"
      >
      {/* Have Questions? */}
        <div className="text-left py-8 pl-[5%] lg:pl-0">
          <h5 className="text-white text-xl font-semibold mb-2">Any questions?</h5>
          <p className="mb-2 text-lg leading-8">
            Ship Sticks is the Official Golf Club and Shipping Provider of Pebble Beach Resorts.
            We passionately and diligently handle guests&apos; golf clubs, luggage, and other
            shipping needs in and out of the property. Should you have any questions or need
            additional information, please call or text us at&nbsp;
            <a className="text-white hover:text-[#6ad687] underline" href="tel:5614293900">
              (561) 429-3900
            </a>.
          </p>
        </div>

        <Newsletter />
      </Footer>
    </>
  );
}
